$(() => {
  $("[data-type=wc-cta]").on("click", function(e) {
    const target = $(this).attr("data-target");
    const href_encoded = $(this).attr("data-cta");

    if (target && target === "_blank") {
      openNewTab(href_encoded);
    } else {
      go(href_encoded);
    }
  });
});
